import { getEmptyGuid } from '../../../components/Utils';

/** Convert the internal 'default' workType key to the empty GUID expected by the API */
export const resolveWorkTypeForApi = (workType: string) => (workType === 'default' ? getEmptyGuid() : workType);
